<template>
    <div class="red_title_row">
        <div class="title_area">
            <p>{{ title }}</p>
        </div>
        <div class="list_area">
            <ul>
                <slot></slot>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {},
    },
};
</script>
<style lang="scss">
.red_title_row {
    display: flex;
    gap: 40px;

    & + .red_title_row {
        margin-top: 30px;
    }

    .title_area {
        flex: 0 0 auto;
        width: 194px;
        padding-top: 20px;
        border-top: 2px solid var(--red);

        p {
            color: var(--red);
            font-family: 'Pretendard', sans-serif;
            font-size: 24px;
            font-weight: 700;
            letter-spacing: -0.025em;
            @media screen and (max-width: 768px) {
                font-size: 22px;
            }
        }
    }

    .list_area {
        flex: 1 0 0;

        ul {
            width: 100%;

            li {
                width: 100%;
                background: var(--gray2);
                list-style: none;
                display: flex;
                gap: 20px;
                padding: 20px 30px;
                align-items: center;
                font-size: 16px;
                @media screen and (max-width: 768px) {
                  font-size: 14px;
                }

                & + li {
                    margin-top: 10px;
                }

                .img_area {
                    margin-right: 20px;
                    margin-left: 10px;
                }

                .text_area {
                    p {
                        font-size: 18px;
                        color: var(--black2);
                        font-family: 'Pretendard', sans-serif;
                        letter-spacing: -0.045em;
                        word-break: keep-all;
                        line-height: 1.6;
                        @media screen and (max-width: 768px) {
                            font-size: 16px;
                        }
                    }
                }
            }
        }
    }
}
</style>
